import { callNuatalker } from '../lib/nuaApi';

async function matchProducts(callApi, clientInfo = null) {
  const productsRequest = callNuatalker({
    path: '/products/v1',
    method: 'GET',
    callApi,
  });

  if (!clientInfo) {
    const products = await productsRequest;
    return [null, products];
  }

  const [bodyClientResponseJson, bodyProductsResponseJson] = await Promise.all([
    Promise.resolve({ results: clientInfo }),
    productsRequest,
  ]);

  return [bodyClientResponseJson, bodyProductsResponseJson];
}

export default matchProducts;
